import { Fragment, useEffect, useState } from "react";
import BackButtonComponent from "../../../NewComponents/BackButton/BackButton.component";
import ToggleTab from "../../../NewComponents/ToggleTab/ToggleTab.component";
import InvestorInfo from "./InvestorInfo";
import InvestorsInvestment from "./InvestorsInvestment";
import { useRouteMatch } from "react-router-dom";
import useFunderDetails from "../../../custom-hooks/useFunderDetails";
import ButtonLoader from "../../../UI/Loaders/Loaders";
import { appInsights } from "../../../config/appInsights";
import PrincipalOrInterestModal from "../Components/PrincipalOrInterestModal/PrincipalOrInterestModal";
import RollOverModal from "../Components/RollOverModal/RollOverModal";
import InvestorsDocuments from "./InvestorsDocument";

export default function InvestorTabs() {
  const [activeTab, setActiveTab] = useState("investor-information");

  const match = useRouteMatch();
  const { id } = match?.params;
  const {
    data: investorData,
    status,
    error,
  } = useFunderDetails({
    pageNumber: 1,
    size: 20,
    FunderId: Number(id),
  });

  useEffect(() => {
    appInsights.trackPageView({
      name: "Investor Details  - (InvestorTabs.jsx)",
      isLoggedIn: true,
    });
  }, []);

  return (
    <Fragment>
      <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
        <h3 className="page-title d-flex align-items-center">
          <BackButtonComponent />{" "}
          {status === "loading" ? (
            <ButtonLoader />
          ) : !error && investorData ? (
            investorData?.data[0]?.first_name +
            " " +
            investorData?.data[0]?.last_name
          ) : (
            ""
          )}
        </h3>
        {/* <div className="d-flex align-items-center justofy-content-center px-3">
          <span>Rollover Investment</span>
          <div className="custom-control custom-switch ml-3 mr-2">
            <button id="custom-rollover-button" className="hidden" />
            <input
              type="checkbox"
              className="custom-control-input"
              id="rolloverSwitch"
              onChange={handleToggleInvestmentRollOver}
              checked={isRollOver}
            />
            <label
              className="custom-control-label cursor-pointer"
              htmlFor="rolloverSwitch"
            />
          </div>
          <span className="d-flex align-items-center">
            <span className="mr-2">{isRollOver ? "On" : "Off"}</span>{" "}
          </span>
        </div> */}
      </div>
      <div className="alignToggleTabItems mb-3">
        <ToggleTab
          text="Investor Details"
          id="investor-information"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <ToggleTab
          text="Investments"
          id="investment-information"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <ToggleTab
          text="Investor KYC Document"
          id="investor-document"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>

      <div>
        {(() => {
          switch (activeTab) {
            case "investor-information":
              return (
                <InvestorInfo
                  investorData={investorData?.data[0]}
                  status={status}
                  error={error}
                />
              );

            case "investment-information":
              return (
                <InvestorsInvestment
                  investorData={investorData?.data[0]}
                  id={Number(id)}
                />
              );

            case "investor-document":
              return <InvestorsDocuments id={Number(id)} />;

            default:
              return null;
          }
        })()}
      </div>
    </Fragment>
  );
}
